import React, { useCallback } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Link, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useMeContext } from 'modules/me';
import { useSessionContext } from 'modules/session';
import { useSubstituteUser } from './hooks/useSubstituteUser';

const useStyles = makeStyles((theme: any) => ({
  root: {
    position: 'absolute',
    width: '100%',
    justifyContent: 'center',
    borderBottom: `solid ${theme.palette.grey[300]} 1px`,
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    height: theme.spacing(4),
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.text.primary
  },
  loggedText: {
    fontWeight: 'normal',
    whiteSpace: 'nowrap'
  },
  user: {
    paddingLeft: theme.spacing(0.5),
    fontWeight: 'bold',
    whiteSpace: 'nowrap'
  },
  returnLink: {
    marginLeft: theme.spacing(3),
    whiteSpace: 'nowrap'
  }
}));

export const SubstituteUserBanner: React.FC = () => {
  const classes = useStyles();
  const me = useMeContext();
  const returnEndpoint = `${me?.wtsUiEndpoint}StopSubstitute/`;
  const { isSubstituteUser } = useSubstituteUser();
  const { setDisableExtendSessionOnFocus } = useSessionContext();

  const stopSubstitute = useCallback(async () => {
    // we are disable session extension on focus, otherwise stop substitute will logout user and paralles session extension will get conflit
    setDisableExtendSessionOnFocus(true);
    //clear actual user session storage
    sessionStorage.removeItem('ACTUALUSERURI');
    window.location.replace(returnEndpoint);
    window.updateTokens(undefined);
  }, [returnEndpoint, setDisableExtendSessionOnFocus]);

  if (!isSubstituteUser) return null;
  return (
    <Stack
      data-testid="substituteUserBanner-id"
      direction={'row'}
      className={classes.root}
    >
      <Typography variant="subtitle2" className={classes.loggedText}>
        <FormattedMessage id="substituteUserBanner.loggedInAs" />
      </Typography>
      <Typography
        data-testid="displayName-id"
        variant="subtitle2"
        className={classes.user}
      >
        {me?.displayText}
      </Typography>
      <Link
        data-testid="linkToReturn-id"
        href="javascript:;"
        onClick={stopSubstitute}
        color="primary"
        underline="none"
        className={classes.returnLink}
      >
        <Typography variant="subtitle2">
          <FormattedMessage id="substituteUserBanner.returnButton" />
        </Typography>
      </Link>
    </Stack>
  );
};

export default SubstituteUserBanner;
